import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as MdIcons from 'react-icons/md';

const Hero = () => {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 1000], [0, 300]);
  const { MdAirportShuttle } = MdIcons;

  return (
    <section id="home" className="relative h-[80vh] md:h-screen min-h-[600px] overflow-hidden bg-black">
      <motion.div style={{ y }} className="absolute inset-0 w-full h-[115%] md:h-[120%]">
        <div 
          className="hero-bg absolute inset-0 bg-no-repeat transition-opacity duration-1000 opacity-100"
          title="South Haven Ride Share LED-lit karaoke van in South Haven Michigan"
          style={{ 
            backgroundImage: 'url("https://media-manager-c.questera.ai/greta-media/7885feab00c7291cee90b78765699762170d35766870b0052ebd1b967ad2d771bc3ae9c57600e107d99e723e518fcb65/images/aW1hZ2UvcG5n/beaa0b7fd37091721e62a0a338be1f50.png")',
            backgroundPosition: '45% 50%', 
            backgroundSize: 'cover',
            filter: 'contrast(1.02) brightness(1.02)',
            imageRendering: 'high-quality',
            WebkitBackfaceVisibility: 'hidden'
          }}
        />
        
        <style dangerouslySetInnerHTML={{ __html: `
          @media (min-width: 768px) {
            .hero-bg { background-position: center 50% !important; }
          }
          @media (max-width: 640px) {
            .hero-bg { 
              background-size: 135% !important; 
              background-position: 40% 50% !important; 
            }
          }
        `}} />
        
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_40%_50%,rgba(0,0,0,0.1)_0%,transparent_70%)]"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black/40"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-transparent to-transparent md:from-black/90"></div>
        <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-black to-transparent"></div>
      </motion.div>

      <div className="relative z-10 h-full flex flex-col justify-center px-6 md:px-12 max-w-7xl mx-auto pt-16 md:pt-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
        >
          <h2 className="text-accent text-[0.6rem] md:text-sm font-sans tracking-[0.6em] uppercase font-bold mb-4 md:mb-8">
            South Haven, Michigan
          </h2>
          
          <h1 className="text-4xl md:text-6xl lg:text-8xl font-serif text-white leading-[1.1] md:leading-[1] mb-10 md:mb-14 max-w-4xl">
            South Haven coast, <br />
            <span className="italic font-light">elevated.</span>
          </h1>
          
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-8 md:gap-12">
            <motion.a 
              href="tel:2699106622"
              whileHover="hover"
              className="group relative inline-flex items-center gap-4 px-10 md:px-14 py-4 md:py-6 bg-accent text-white font-sans text-xs md:text-sm tracking-[0.2em] uppercase font-bold overflow-hidden transition-all duration-300 rounded-full hover:shadow-[0_0_50px_rgba(230,161,92,0.4)]"
            >
              <span className="relative z-10 flex items-center gap-3">
                Book Chris
                <motion.div
                  variants={{
                    hover: { 
                      x: [0, 45, -45, 0],
                      opacity: [1, 0, 0, 1],
                    }
                  }}
                  transition={{ duration: 0.9, ease: "easeInOut" }}
                >
                  <SafeIcon icon={MdAirportShuttle} className="text-xl" />
                </motion.div>
              </span>
              <div className="absolute inset-0 bg-white/10 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
            </motion.a>

            <div className="h-px w-12 md:w-20 bg-white/20 hidden sm:block"></div>
            
            <p className="text-white/90 font-light text-lg md:text-2xl max-w-xl font-serif italic border-l-2 border-accent pl-8 leading-relaxed">
              Your premier South Haven transportation partner for beach-side hotels and reliable late-night safe rides.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;